import viewController from 'sky-engine/views/viewController'

import PocDetail from './pocDetail'

const SkyPocProjectDetailController = {
  name: 'SkyPocProjectDetailController',
  components: {
    PocDetail
  },
  extends: viewController,
  provide() {
    return {
      PocDetail: this
    }
  },
  props: {
    views: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  created() {},
  data() {
    return {}
  },
  mounted() {},
  methods: {
    autoRefresh() {
      this.$refs.pocDetail.refresh()
    },
    renderContent(h) {
      return <poc-detail ref="pocDetail"></poc-detail>
    }
  }
}

export default SkyPocProjectDetailController
